import { render, staticRenderFns } from "./UploadAttachment.vue?vue&type=template&id=174f5880&scoped=true"
import script from "./UploadAttachment.vue?vue&type=script&lang=js"
export * from "./UploadAttachment.vue?vue&type=script&lang=js"
import style0 from "./UploadAttachment.vue?vue&type=style&index=0&id=174f5880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174f5880",
  null
  
)

export default component.exports